export enum CarryoverApprovalStatus {
  Unset = 0,

  AutoApproved = 1,
  AutoRejected = 2,
  ManuallyApproved = 3,
  ManuallyRejected = 4,
  Requested = 5,
  NotRequested = 6,
}
